import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import ReportCardPageUI from './ReportCardPageUI.js'

class ReportCardPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            loan: null,
            repayments: null,
            repaymentList: null,
            loanRemarksCs: null,
            monitoringRemarksList: null
        }
    }

    render() {
        return (
            <ReportCardPageUI
                context={this.props.context}
                errorList={this.state.errorList}
                loan={this.state.loan}
                account={this.state.account}
                repayments={this.state.repayments}
                repaymentList={this.state.repaymentList}
                loanRemarksCs={this.state.loanRemarksCs}
                monitoringRemarksList={this.state.monitoringRemarksList}
                onRefreshClick={this.onRefreshClick}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getLoan(context)
        this.getRepayments(context)
        this.getLoanRemarksCs(context)
        this.getMonitoringRemarks(context)
    }

    getLoan(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/loans/${this.props.match.params.loanId}`,
            cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
            callback: this.getLoanCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getLoanCallback = (response) => {
        let context = this.props.context
        this.setState({ errorList: response.errorList, loan: response.loan })
        this.getAccount(context, response.loan.accountId)
    }

    getAccount(context, accountId) {
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/${accountId}`,
            cacheKey: CacheKeys.Account(accountId),
            callback: this.getAccountCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getAccountCallback = (response) => {
        this.setState({ account: response.account })
    }

    getRepayments(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/loans/${this.props.match.params.loanId}/repayments`,
            cacheKey: CacheKeys.Repayments(this.props.match.params.loanId),
            callback: this.getRepaymentsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getRepaymentsCallback = (response) => {
        let repayments = response
        this.setState({ errorList: response.errorList, repaymentList: response.repaymentList, repayments: repayments })
    }

    getLoanRemarksCs(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/cs/remarks`,
            cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'cs'),
            callback: this.getLoanRemarksCsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getLoanRemarksCsCallback = (response) => {
        this.setState({ errorList: response.errorList, loanRemarksCs: response.remarksList })
    }

    getMonitoringRemarks(context) {
        let cacheManager = new CacheManager({
            resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/monitoring/remarks`,
            cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'monitoring'),
            callback: this.getMonitoringRemarksCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getMonitoringRemarksCallback = (response) => {
        this.setState({ errorList: response.errorList, monitoringRemarksList: response.remarksList })
    }

    onRefreshClick = (noBusy) => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.Loan(this.state.loan.loanId))
        CacheManager.removeObject(CacheKeys.Repayments(this.state.loan.loanId))
        CacheManager.removeObject(CacheKeys.LoanRemarks(this.state.loan.loanId, 'cs'))
        CacheManager.removeObject(CacheKeys.LoanRemarks(this.state.loan.loanId, 'monitoring'))
        if (noBusy === 'noBusy') {
            this.getLoan(context)
            this.getRepayments(context)
            this.getLoanRemarksCs(context)
        }
        else {
            this.setState({
                loan: null,
                errorList: null,
                repayments: null,
                repaymentList: null,
                loanRemarksCs: null,
                monitoringRemarksList: null
            })
            this.getLoan(context)
            this.getRepayments(context)
            this.getLoanRemarksCs(context)
        }
    }
}

export default withRouter(ReportCardPageSF)
